import Vue from 'vue';
import { Component, Prop, PropSync, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import * as types from '@appbase/store/types';

@Component({
    computed: {
    ...mapGetters({
        message: types.LOADING_BAR_MESSAGE,
    }),
    },
})
export default class LoadingBar extends Vue {
    message!: string;

    get getMessage() {
        if (!this.message) {
            return this.$t('로딩중입니다__잠시만_기다려주세요');
        } else {
            return this.message;
        }
    }

    created() {

    }
}

